import styles from './CarriersCarousel.module.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import RetinaImage from 'src/components/RetinaImage';

import LogoCanadaPost from 'src/images/logo-canada-post.png';
import LogoCanadaPost2x from 'src/images/logo-canada-post@2x.png';
import LogoCanadaPost3x from 'src/images/logo-canada-post@3x.png';
import LogoDHLEcommerce from 'src/images/logo-dhl-ecommerce.png';
import LogoDHLEcommerce2x from 'src/images/logo-dhl-ecommerce@2x.png';
import LogoDHLEcommerce3x from 'src/images/logo-dhl-ecommerce@3x.png';
import LogoDHLExpress from 'src/images/logo-dhl-express.png';
import LogoDHLExpress2x from 'src/images/logo-dhl-express@2x.png';
import LogoDHLExpress3x from 'src/images/logo-dhl-express@3x.png';
import LogoFedEx from 'src/images/logo-fedex.png';
import LogoFedEx2x from 'src/images/logo-fedex@2x.png';
import LogoFedEx3x from 'src/images/logo-fedex@3x.png';
import LogoFirstMile from 'src/images/logo-first-mile.png';
import LogoFirstMile2x from 'src/images/logo-first-mile@2x.png';
import LogoNewgistics from 'src/images/logo-newgistics.png';
import LogoNewgistics2x from 'src/images/logo-newgistics@2x.png';
import LogoNewgistics3x from 'src/images/logo-newgistics@3x.png';
import LogoOnTrac from 'src/images/logo-ontrac.png';
import LogoOnTrac2x from 'src/images/logo-ontrac@2x.png';
import LogoOnTrac3x from 'src/images/logo-ontrac@3x.png';
import LogoPostageOne from 'src/images/logo-postage-one.png';
import LogoPostageOne2x from 'src/images/logo-postage-one@2x.png';
import LogoUPS from 'src/images/logo-ups.png';
import LogoUPS2x from 'src/images/logo-ups@2x.png';
import LogoUPS3x from 'src/images/logo-ups@3x.png';
import LogoUSPS from 'src/images/logo-usps.png';
import LogoUSPS2x from 'src/images/logo-usps@2x.png';
import LogoUSPS3x from 'src/images/logo-usps@3x.png';

class CarrierCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.rotateLeft = this.rotateLeft.bind(this);

    this.rotationIntervalId = null;
    this.removeChildTimeoutId = null;
  }

  componentDidMount() {
    this.rotationIntervalId = setInterval(() => {
      this.rotateLeft();
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.rotationIntervalId);
    clearTimeout(this.removeChildTimeoutId);
  }

  rotateLeft() {
    const tapeEl = ReactDOM.findDOMNode(this.tapeRef),
          firstLogoEl = tapeEl.firstElementChild,
          firstLogoElStyle = (window.getComputedStyle
                              ? window.getComputedStyle(firstLogoEl, null)
                              : firstLogoEl.currentStyle),
          marginLeft = parseInt(firstLogoElStyle.marginLeft) || 0,
          marginRight = parseInt(firstLogoElStyle.marginRight) || 0,
          firstLogoElWidth = firstLogoEl.offsetWidth + marginLeft + marginRight;

    // Implements a ghetto rotate animation: animate the `margin-left` off
    // screen, then remove the child and append it to the end of the tape.
    firstLogoEl.style.marginLeft = `${marginLeft - firstLogoElWidth}px`;

    this.removeChildTimeoutId = setTimeout(() => {
      tapeEl.removeChild(firstLogoEl);
      firstLogoEl.style.marginLeft = `${marginLeft}px`;
      tapeEl.appendChild(firstLogoEl);
    }, 400);
  }

  render() {
    return (
      <div {...this.props}
           className={this.props.className}
           styleName='carriers-carousel'>
          <div styleName='tape' ref={(ref) => {this.tapeRef = ref;}}>
              <RetinaImage styleName='logo' srcSet={[LogoUPS, LogoUPS2x, LogoUPS3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoFedEx, LogoFedEx2x, LogoFedEx3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoDHLEcommerce, LogoDHLEcommerce2x, LogoDHLEcommerce3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoUSPS, LogoUSPS2x, LogoUSPS3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoNewgistics, LogoNewgistics2x, LogoNewgistics3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoOnTrac, LogoOnTrac2x, LogoOnTrac3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoCanadaPost, LogoCanadaPost2x, LogoCanadaPost3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoDHLExpress, LogoDHLExpress2x, LogoDHLExpress3x]} />
              <RetinaImage styleName='logo' srcSet={[LogoPostageOne, LogoPostageOne2x]} />
              <RetinaImage styleName='logo' srcSet={[LogoFirstMile, LogoFirstMile2x]} />
          </div>
      </div>
    );
  }
}

export default CarrierCarousel;



// WEBPACK FOOTER //
// ./src/components/CarriersCarousel.js